module.exports = {"verification.modal.content.text":"A verification has been sent to your email address. To complete activation, click the verification link in the email and then return to this page.","verification.modal.content.status":"Waiting for email verification"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/components/ModalContent/Verification.json
// module id = 725
// module chunks = 0